<template>
    <div class="foot">
        <div class="container">
            <div class="row">
                <div class="p-b-10 t-center">
                    <img src="../assets/img/p.png" style="height:60px;" />
                </div>
               
            </div>
            <div class="row m-t-20">
                <div class="gradient-text">
                    Sign up today and begin creating clear, concise service contracts for your <br>
                    clients and sub-contractors quickly and easily!
                   
                </div>
            </div>
            <div class="row">
                <div style="margin:20px auto;  display:flex; align-items:center; justify-content:center; ">
                    <a href="/blog" class="mr-4 hover:!text-green-600" style="text-decoration: none; color: #112035; font-weight: bold; ">Blog</a>
                    <div style="background-color:white; padding:4px; border-radius:4px;">
                        <div class="btn-signin text-[#C3E550]" onclick="window.location.href='/login'">Sign in</div>
                        <div class="btn-signup" onclick="window.location.href='/login?t=signup'">Sign Up</div>
                    </div>

                </div>

            </div>

            <div class="row">
                <div class="footer-text">
                    <div style="cursor:pointer; text-align:center;" onclick="window.location.href='/eula'">End User License Agreement</div>
                    <div>Contact Us At: <a style="font-weight:normal; color:#222; text-decoration:none;" href="mailto:info@contractly.ca"> info@Contractly.ca </a></div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'Foot',
        data() {
            return {}
        },
        mounted() {},
        methods: {}
    };
</script>
<style scoped>
    .gradient-text {
        
        font-size: clamp(12px, 1.5vw, 34px); /* Dynamic font size */
        font-weight: bold;
        color: #222; /* Fallback color */
        text-align: center;
    }

        .gradient-text .gradient {
            background: linear-gradient(90deg, #134144, #4f4fb8);
            background-clip: text; /* Add this line */
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .gradient-text .gradient2 {
            background: linear-gradient(90deg, #406d9d, #5e59d5);
            background-clip: text; /* Add this line */
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .gradient-text .gradient3 {
            background: linear-gradient(90deg, #5e59d5, #406d9d);
            background-clip: text; /* Add this line */
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    .footer-text {
        justify-content: center;
        display: flex;
        gap: 20px;
        font-size: clamp(12px, 1.5vw, 20px);
        font-weight: bold;
        color: #222;
    }
</style>